import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getUsers as getUsersFromMonolith, GetUsersOptions, User } from '~/monolith-api';

export type { GetUsersOptions, User };

const getUsersSchema = z.object({
   limit: z.number().optional(),
   offset: z.number().optional(),
   order: z.enum(['ASC', 'DESC']).optional(),
   joinedSince: z.number().optional(),
});

export async function getUsers(options: GetUsersOptions | undefined) {
   return await getUsersFromMonolith(options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { limit, offset, order, joinedSince } = getUsersSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getUsersFromMonolith({
         limit,
         offset,
         order,
         joinedSince,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getUsersFromClient = (options?: GetUsersOptions): ReturnType<typeof getUsers> => {
   return bff()
      .post('/users/getUsers', {
         ...options,
      })
      .then(response => response.data);
};
